import { render } from "./WebVid.vue?vue&type=template&id=2935be9a&scoped=true"
const script = {}

import "./WebVid.vue?vue&type=style&index=0&id=2935be9a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2935be9a"]])

export default __exports__